import React, { useEffect, useState } from "react";
import axios from "../../../utils/axios";
import { message, Spin } from "antd";
import { Users } from "lucide-react";

import EducationStaffSummary from "../education/educationStaffSum";

const StaffSummary = () => {

  const organizationId = localStorage.getItem("organizationId");
  const projectname = localStorage.getItem("selectedProject");
  const user = JSON.parse(localStorage.getItem("user"));

  const [sector, setSector] = useState(null);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH PROJECT DETAILS ---------------- */

  const getProjectDetails = async () => {

    try {

      setLoading(true);

      const res = await axios.post("/get-project-details", {
        projectName: projectname,
        organizationId
      });

      if (res?.data?.project?.mainCategory) {
        setSector(res.data.project.mainCategory);
      }

    } catch (err) {
      message.error("Error loading project details");
    } finally {
      setLoading(false);
    }

  };

  /* ---------------- FETCH PAGE CONFIG ---------------- */

  const fetchConfig = async () => {

    try {

      const res = await axios.post("/fetch-dashboard-settings", {
        organizationId,
        username: user?.username,
        projectname
      });

      if (res.data?.success) {
        setConfig(res.data.data.pages?.["staff-summary"]);
      }

    } catch (err) {
      message.error("Failed to load staff summary config");
    }

  };

  useEffect(() => {
    getProjectDetails();
    fetchConfig();
  }, [projectname]);

  /* ---------------- SECTOR ROUTER ---------------- */

  const PageRouter = () => {

    switch (sector) {

      case "Education":
        return <EducationStaffSummary config={config} />;

      default:
        return (

          <div className="flex items-center justify-center h-[400px] text-gray-500">
            No Staff Summary Available
          </div>

        );

    }

  };

  /* ---------------- LOADING ---------------- */

  if (loading) {

    return (

      <div className="flex items-center justify-center h-[500px]">
        <Spin size="large" />
      </div>

    );

  }

  /* ---------------- UI ---------------- */

  return (

    <div className="max-w-7xl mx-auto">

      {/* PAGE HEADER */}

      <div className="mb-8">

        <h1 className="flex items-center gap-2 text-3xl font-bold text-gray-800">

          <Users className="w-7 h-7 text-blue-600" />

          Staff Summary

        </h1>

        <p className="text-gray-500 mt-1">
          Overview of staff attendance, working hours and activity insights
        </p>

      </div>

      {/* PAGE CONTENT */}

      <div>

        <PageRouter />

      </div>

    </div>

  );

};

export default StaffSummary;